import React from "react";
import icon from "../assets/icon.png";

export default function UnderConstruction() {
  return (
    <main className="relative min-h-screen w-full flex items-center justify-center px-4 md:px-12 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none -z-10">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-orange-100/40 rounded-full blur-3xl opacity-60 mix-blend-multiply"></div>
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] md:w-[600px] md:h-[600px] bg-teal-50/40 rounded-full blur-3xl opacity-30 md:opacity-60 mix-blend-multiply"></div>
      </div>

      <div className="w-full max-w-3xl flex flex-col items-center justify-center gap-10 animate-slideInBounce">
        <div className="relative w-40 h-40 md:w-56 md:h-56 group">
          <div className="absolute -inset-4 border border-dashed border-orange-300/40 rounded-[3rem] animate-[spin_10s_linear_infinite] -z-20"></div>
          <div className="absolute -inset-4 border border-teal-300/30 rounded-[3rem] animate-[spin_15s_linear_infinite_reverse] -z-20 scale-105"></div>

          <div className="relative w-full h-full rounded-[2.5rem] overflow-hidden shadow-2xl ring-1 ring-white/50 bg-white/60">
            <img
              src={icon}
              alt="רון מצרפי"
              className="w-full h-full object-contain p-4"
            />
          </div>
        </div>

        <div className="group relative w-full">
          <div className="absolute -inset-1 bg-gradient-to-r from-teal-200 to-orange-200 rounded-[2.5rem] blur opacity-20 transition duration-1000"></div>

          <div className="relative bg-white/40 backdrop-blur-2xl p-8 md:p-12 rounded-[2.5rem] shadow-sm">
            <div className="absolute top-6 left-6 text-2xl opacity-40 animate-pulse text-orange-300">
              ✨
            </div>
            <div className="absolute bottom-6 right-6 text-2xl opacity-40 animate-pulse text-teal-300">
              ✨
            </div>

            <div className="flex flex-col items-center text-center gap-4" dir="rtl">
              <h1 className="text-4xl md:text-6xl font-['Frank_Ruhl_Libre'] font-bold text-stone-800 tracking-wide drop-shadow-sm">
                האתר בבנייה
              </h1>

              <p className="text-xl md:text-2xl font-['Frank_Ruhl_Libre'] font-medium text-stone-600 leading-relaxed">
                חוזרים בקרוב עם חוויה מחודשת
              </p>

              <div className="w-24 h-[1px] bg-gradient-to-r from-transparent via-orange-300/60 to-transparent my-2"></div>

              <p className="text-lg md:text-xl font-['Frank_Ruhl_Libre'] text-orange-400 font-medium tracking-wider">
                רון מצרפי
              </p>
            </div>

            <div className="absolute top-0 left-10 right-10 h-[1px] bg-gradient-to-r from-transparent via-white/80 to-transparent opacity-50"></div>
          </div>
        </div>
      </div>
    </main>
  );
}
